module.exports = __webpack_public_path__ + "media/5.15797055.wav";